import { UserServices } from "../services";
import { useEffect, useState, useMemo } from "react";
import { AccountModel } from "shared/model";

export const useAccount = (): AccountModel | null => {
	const [time, setTime] = useState(Date.now()); // Força atualização quando o usuário muda
	const [user, setUser] = useState<AccountModel | null>(UserServices.currentUser);

	useEffect(() => {
		UserServices.ready((user) => {
			setUser(user);
		});

		const event = UserServices.onAuthStateChanged((user) => {
			setUser(user);
		});

		return () => {
			event.stop();
		};
	}, []);

	useEffect(() => {
		if (!user) return;

		const onChange = () => {
			setTime(Date.now());
		};

		const effects = [user.on("update", onChange), user.on("clear", onChange)];

		return () => {
			effects.forEach((effect) => effect.stop());
		};
	}, [user]);

	return useMemo(() => user, [user, time]);
};
